var SolutionBundleController = (function () {
    function SolutionBundleController() {
        this.protocols = [];
    }
    SolutionBundleController.prototype.$onInit = function () {
        this.bundle.drItem = this.bundle.bundle.map(function (b) {
            return {
                groupId: b.groupId,
                name: b.productName,
                sku: b.sku,
            };
        });
        this.protocols.push(this.bundle.protocol.id);
    };
    SolutionBundleController.prototype.hasProtocol = function () {
        if (!this.bundle) {
            return false;
        }
        if (!this.bundle.protocol) {
            return false;
        }
        var protocol = this.bundle.protocol;
        var settings = protocol.settings;
        var notes = protocol.notes;
        return Boolean(notes) || (Array.isArray(settings) && settings.length > 0);
    };
    return SolutionBundleController;
}());
export var SolutionBundleComponent = {
    bindings: {
        bundle: '<',
        segmentType: '=',
    },
    controller: SolutionBundleController,
    templateUrl: 'compatibilityguide/ng-templates/feature/search/solutionbundle',
};
